import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { CountdownTimer } from './components/CountdownTimer';
import { CopiesCounter } from './components/CopiesCounter';
import { HeroSection } from './components/HeroSection';
import { BonusScrollStopper } from './components/BonusScrollStopper';
import { EmpathySection } from './components/EmpathySection';
import { BonusOne } from './components/BonusOne';
import { AuthoritySection } from './components/AuthoritySection';
import { WhyDidntWorkSection } from './components/WhyDidntWorkSection';
import { TTPMMechanismSection } from './components/TTPMMechanismSection';
import { BonusTwo } from './components/BonusTwo';
import { ProductSection } from './components/ProductSection';
import { ComparativeSection } from './components/ComparativeSection';
import { EmotionalSection } from './components/EmotionalSection';
import { BonusThree } from './components/BonusThree';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { BonusFour } from './components/BonusFour';
import { ValueStackSummary } from './components/ValueStackSummary';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalClosingSection } from './components/FinalClosingSection';
import { Footer } from './components/Footer';
import { RecentPurchaseNotification } from './components/RecentPurchaseNotification';
export function App() {
  return <div className="w-full min-h-screen bg-[#070B16] text-[#f3f4f6] font-sans overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />

      <Header data-id="element-2" />
      <CountdownTimer data-id="element-3" />
      <CopiesCounter data-id="element-4" />

      <main data-id="element-5">
        <HeroSection data-id="element-6" />
        <BonusScrollStopper data-id="element-7" />
        <EmpathySection data-id="element-8" />
        <BonusOne data-id="element-9" />
        <AuthoritySection data-id="element-10" />
        <WhyDidntWorkSection data-id="element-11" />
        <TTPMMechanismSection data-id="element-12" />
        <BonusTwo data-id="element-13" />
        <ProductSection data-id="element-14" />
        <ComparativeSection data-id="element-15" />
        <EmotionalSection data-id="element-16" />
        <BonusThree data-id="element-17" />
        <TestimonialsSection data-id="element-18" />
        <WhoIsForSection data-id="element-19" />
        <BonusFour data-id="element-20" />
        <ValueStackSummary data-id="element-21" />
        <PricingSection data-id="element-22" />
        <GuaranteeSection data-id="element-23" />
        <FAQSection data-id="element-24" />
        <FinalClosingSection data-id="element-25" />
      </main>

      <Footer data-id="element-26" />
      <RecentPurchaseNotification data-id="element-27" />
    </div>;
}